module.exports = __webpack_public_path__ + "static/img/wait.4c0fead.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wait.png
// module id = 121
// module chunks = 7